// extracted by mini-css-extract-plugin
export default {"tab_content_main":"Profile_tab_content_main__RfCWU","tabs_wrapper":"Profile_tabs_wrapper__056TS"};